import React from 'react'
import { Link } from "react-router-dom"
import { GlobalContext } from "../../Context/Context"
const LatestArticleComponent = () => {
    const context = React.useContext(GlobalContext)
    const latestArticles = context.common.latestArticles

    const ArticleItem = ({ article }) => <li>
        <div>
            <Link
                to={{
                    pathname: "/view-article",
                    state: {
                        articleID: article.IdArticle
                    }
                }}>{article.ArticleName}</Link>

        </div>
        {/* <p>{article.ShortDescription}</p> */}

    </li>
    return (<div className="latest_box">
        <div className="latest_header_box">
            <h5>Latests</h5>
        </div>
        <div className="latest_body_box">
            <ul>
                {latestArticles.map((article, i) => <ArticleItem article={article} key={i} />)}
            </ul>
        </div>
    </div>)
}
export default LatestArticleComponent